import * as theme from '../../theme'
import {
  ActionableComponent,
  ClickableComponent,
  HoverableComponent,
  FocusableComponent,
  RefableComponent,
  DisableableComponent,
} from '../../types/BaseComponents'

export const IconSizes = {
  sm: '12px',
  md: '16px',
  lg: '20px',
  xl: '24px',
}

export const IconColors = {
  yellow: theme.lightTheme.colors.yellow.DEFAULT,
  red: theme.lightTheme.colors.red.DEFAULT,
  blue: theme.lightTheme.colors.blue.DEFAULT,
  green: theme.lightTheme.colors.green.DEFAULT,
  white: theme.lightTheme.colors.white.DEFAULT,
  default: theme.lightTheme.colors.black.DEFAULT,
}

export interface BaseIconProps
  extends ActionableComponent,
    ClickableComponent<SVGSVGElement>,
    HoverableComponent,
    FocusableComponent<SVGSVGElement>,
    RefableComponent<SVGSVGElement>,
    DisableableComponent {
  size?: keyof typeof IconSizes
  color?: keyof typeof IconColors
}
